var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalBackgroundDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 519,
    height: 400,
    viewBox: "0 0 519 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2557_361581)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.442 420.463C379.902 372.013 450.108 293.15 502.263 321.673C554.417 350.196 520.289 395.116 471.478 369.715C422.668 344.314 453.559 283.217 507.939 255.583C562.32 227.949 593.425 222.615 605.739 189.374C618.053 156.134 579.477 96.9437 544.132 124.436C508.786 151.927 579.012 204.174 641.397 129.178C691.305 69.1816 711.187 27.7196 714.889 14.4881",
    stroke: "#E2E6E5",
    strokeWidth: 31.4902
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.442 420.463C379.902 372.013 450.108 293.15 502.263 321.673C554.417 350.196 520.289 395.116 471.478 369.715C422.668 344.314 453.559 283.217 507.939 255.583C562.32 227.949 593.425 222.615 605.739 189.374C618.053 156.134 579.477 96.9437 544.132 124.436C508.786 151.927 579.012 204.174 641.397 129.178C691.305 69.1816 711.187 27.7196 714.889 14.4881",
    stroke: "white",
    strokeWidth: 24.7641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.442 420.463C379.902 372.013 450.108 293.15 502.263 321.673C554.417 350.196 520.289 395.116 471.478 369.715C422.668 344.314 453.559 283.217 507.939 255.583C562.32 227.949 593.425 222.615 605.739 189.374C618.053 156.134 579.477 96.9437 544.132 124.436C508.786 151.927 579.012 204.174 641.397 129.178C691.305 69.1816 711.187 27.7196 714.889 14.4881",
    stroke: "#E2E6E5",
    strokeWidth: 22.0126
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.442 420.463C379.902 372.013 450.108 293.15 502.263 321.673C554.417 350.196 520.289 395.116 471.478 369.715C422.668 344.314 453.559 283.217 507.939 255.583C562.32 227.949 593.425 222.615 605.739 189.374C618.053 156.134 579.477 96.9437 544.132 124.436C508.786 151.927 579.012 204.174 641.397 129.178C691.305 69.1816 711.187 27.7196 714.889 14.4881",
    stroke: "white",
    strokeWidth: 1.22292,
    strokeLinejoin: "round",
    strokeDasharray: "4.89 4.89"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-199.028 243.143C98.8118 110.324 81.4296 395.316 -98.6625 490.896",
    stroke: "#E2E6E5",
    strokeWidth: 31.4902
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-199.028 243.143C98.8118 110.324 81.4296 395.316 -98.6625 490.896",
    stroke: "white",
    strokeWidth: 24.7641
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-199.028 243.143C98.8118 110.324 81.4296 395.316 -98.6625 490.896",
    stroke: "#E2E6E5",
    strokeWidth: 22.0126
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-199.028 243.143C98.8118 110.324 81.4296 395.316 -98.6625 490.896",
    stroke: "white",
    strokeWidth: 1.22292,
    strokeLinejoin: "round",
    strokeDasharray: "4.89 4.89"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2557_361581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 519,
    height: 400,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBackgroundDecor);
export default __webpack_public_path__ + "static/media/modal-background-decor.a0b66f9b8432365fc1d32827a09d35b8.svg";
export { ForwardRef as ReactComponent };